import { useEffect } from 'react';
import { useAppDispatch } from 'shared/helpers/useAppDispatch/useAppDispatch';
import { fetchGameState } from '../services/fetchGameService';

export const useGameState = (gameId: string | undefined, isAuth: boolean) => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (isAuth && gameId) {
      dispatch(fetchGameState(gameId));
    }
  }, [dispatch, gameId, isAuth]);
};
